import { render, staticRenderFns } from "./loud.vue?vue&type=template&id=64ccb650"
import script from "./loud.vue?vue&type=script&lang=js"
export * from "./loud.vue?vue&type=script&lang=js"
import style0 from "./loud.vue?vue&type=style&index=0&id=64ccb650&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports